import { connect } from 'react-redux';
import {
  compose,
  lifecycle,
  setDisplayName,
  withHandlers,
  withState,
} from 'recompose';
import notify from '@/migration/notification';
import { bindActionCreators } from 'redux';
import { appAction, salesAction, usersAction } from '@/actions';

const mapStateToProps = (state) => ({
  sales: state.sales.toJS(),
  users: state.users.toJS(),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...salesAction, ...appAction, ...usersAction },
    dispatch
  );
const enhance = compose(
  setDisplayName('Credit'),
  withState('pageOfItems', 'pageOfItemsUpdater', []),
  withState('isLoading', 'isLoadingUpdater', false),
  withState('open', 'toggleModal', false),
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onChangePage: (props) => (pageOfItems) => {
      const { pageOfItemsUpdater } = props;

      pageOfItemsUpdater(pageOfItems);
    },
    handleDeleteCreditCard: (props) => async () => {
      const { deleteUserCards } = props;

      try {
        await deleteUserCards(props.users.mydata.id);
        notify('カード情報を削除しました。', 'info', undefined, 5);
      } catch (error) {
        notify(error.message, 'error', undefined, 5);
      }
    },
  }),
  lifecycle({
    async componentDidMount() {
      this.props.isLoadingUpdater(true);
      await this.props.getMe();
      await this.props.getUserCards(this.props.users.mydata.id);
      this.props.isLoadingUpdater(false);
    },
  })
);

export default enhance;
